import React from "react";
import { CLIENT_STRIP } from "@/lib/lumiqoData";

const Row = () => (
  <div className="flex items-center gap-12 sm:gap-16 shrink-0 px-6">
    {CLIENT_STRIP.map((c) => (
      <div
        key={c}
        className="font-display font-semibold text-base sm:text-lg text-[#0a1d4d]/55 whitespace-nowrap tracking-tight"
      >
        {c}
      </div>
    ))}
  </div>
);

const Marquee = () => {
  return (
    <section
      className="relative py-10 sm:py-14 bg-[#f5f6fa] border-y border-[#0a1d4d]/5"
      data-testid="clients-marquee"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 mb-6 sm:mb-8 flex items-center justify-center">
        <span className="text-xs uppercase tracking-[0.22em] text-[#0a1d4d]/55 font-semibold">
          Trusted across platforms & niches
        </span>
      </div>
      <div className="relative overflow-hidden lq-mask-fade-x">
        <div className="flex lq-marquee w-max">
          <Row />
          <Row />
        </div>
      </div>
    </section>
  );
};

export default Marquee;
